import type { LeadProfileLead } from '../components/LeadProfileModal/LeadProfileModal.types'

const seedByLeadId = new Map<number, LeadProfileLead>()

export const setCrmLeadDeepLinkSeed = (lead: LeadProfileLead) => {
  const leadId = Number(lead.id)
  if (!Number.isFinite(leadId) || leadId <= 0) return
  seedByLeadId.set(leadId, lead)
}

export const peekCrmLeadDeepLinkSeed = (
  leadId: number,
): LeadProfileLead | undefined => {
  return seedByLeadId.get(leadId)
}

export const clearCrmLeadDeepLinkSeed = (leadId?: number) => {
  if (leadId != null && Number.isFinite(leadId)) {
    seedByLeadId.delete(leadId)
    return
  }
  seedByLeadId.clear()
}

/** Cold deep link без seed: сразу открыть карточку с версткой + blur, пока идёт bootstrap-refetch. */
export const createCrmLeadDeepLinkStub = (
  leadId: number,
  funnelId?: number | null,
): LeadProfileLead => {
  const numericFunnelId = Number(funnelId)
  const hasFunnel =
    Number.isFinite(numericFunnelId) && numericFunnelId > 0
      ? Math.trunc(numericFunnelId)
      : null

  return {
    id: leadId,
    type: 'new',
    fields: [],
    manager: null,
    created_at: '',
    traffic_channel: null,
    currentFunnelId: hasFunnel,
    funnel: hasFunnel != null ? { id: hasFunnel, name: '' } : null,
    funnels:
      hasFunnel != null
        ? [{ id: hasFunnel, name: '', isPrimary: true }]
        : [],
  }
}
